import { oz } from '@weft/utils';
import { ApiDateSchema, ObjectIdSchema } from '../../primitives';
import { EVENT_METERING_STATUSES, EventMeteringStatusSchema } from './event-metering-status';
import { IngestedEventSchema } from './ingested-event-schema';

export const NewEventSchema = IngestedEventSchema.extend({
  customerId: ObjectIdSchema.optional(),
  meteringStatus: EventMeteringStatusSchema.default(EVENT_METERING_STATUSES.Ingested),
});

export type NewEvent = oz.infer<typeof NewEventSchema>;

export const CreatedEventSchema = IngestedEventSchema.extend({
  id: oz.string(),
  updatedAt: ApiDateSchema,
  createdAt: ApiDateSchema,
});

export type CreatedEvent = oz.infer<typeof CreatedEventSchema>;